import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import MoreVertIcon from '@material-ui/icons/MoreVert';

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { baseTheme } from '../../../theme';
import { clearLibrary, createLibraryPostAction } from '../../../store/library/actions';
import { postGroupIsClosed } from '../../../services/posts';
import ShareModal from '../../share-components/share-modal';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(0),
      paddingRigth: theme.spacing(0),
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
      height: '600px',
      overflowY: 'scroll',
      border: `solid 1px ${theme.palette.primary.main}`,
    },
    menuList: {
      padding: theme.spacing(0),
    },
  }),
);

export default function GroupPostMenu(props: any) {
  const { id, post, groupType } = props;
  const classes = useStyles(baseTheme);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const currUser = useSelector((state: any) => state.auth.currUser);
  const dispatch = useDispatch();

  const onHoverOverMenu = (event: any) => {

  };

  const onHoverOutMenu = (event: any) => {

  };

  const handleClose = (event: any) => {
    setMenuOpen(false);
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleMenuAction = (event: any) => {
    // console.log(event);
    event.stopPropagation();
    setMenuOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleCopy = (event: any) => {
    handleClose(event);
    createLibraryPostAction(currUser.uid, props.post);
    clearLibrary(dispatch);
  };

  const handlePrint = (event: any) => {
    handleClose(event);
    console.log('I would enter print mode.......');
  };

  const handleShare = (event: any) => {
    setMenuOpen(false);
    setShareModalOpen(true);
  };
  const closeShareModal = () => {
    setShareModalOpen(false);
  };
  const iconColor = groupType === 'Public'
      ? 'primary'
      : groupType === 'Closed'
          ? 'secondary'
          : undefined;
  const mouseEnter = (e: any) => e.target.style.backgroundColor = 'rgba(0, 101, 207, 1.0)';
  const mouseLeave = (e:any) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 1.0)';
  return (
    <>
      <IconButton
        onClick={handleMenuAction}
        onMouseOver={onHoverOverMenu}
        onMouseOut={onHoverOutMenu}
      >
        <MoreVertIcon color={iconColor}/>
      </IconButton>
      <Popover
        id={id}
        open={menuOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        onMouseOver={onHoverOverMenu}
        onMouseOut={onHoverOutMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuList className={classes.menuList}>
          <MenuItem
            onMouseEnter={postGroupIsClosed(post) ? mouseEnter : () => null}
            onMouseLeave={postGroupIsClosed(post) ? mouseLeave : () => null}
            onClick={handleCopy}>Copy post to Library</MenuItem>
          {!postGroupIsClosed(post) && <MenuItem onClick={handleShare}>Share</MenuItem>}
        </MenuList>
      </Popover>
      <Popover
          open={shareModalOpen}
          anchorEl={anchorEl}
          onClose={closeShareModal}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
      >
        <ShareModal post={post} isOpen={shareModalOpen} closeShareModal={closeShareModal} />
      </Popover>
    </>
  );
}
